import { TenantFeatureFlag } from '@recurrency/core-api-schema/dist/common/enums';
import { TenantSettingKey } from '@recurrency/core-api-schema/dist/common/tenantSettings';
import { TenantDTO } from '@recurrency/core-api-schema/dist/tenants/tenantDTO';

import { MultiSelectOption } from 'components/AsyncSelect/types';
import { DemandPredictabilityTag } from 'components/recipes/DemandPredictabilityTag';
import { DemandPattern, DemandPatternChange } from 'components/Tooltip/DemandPatternTooltip';

import type { ExtendedUser } from 'hooks/useGlobalApp';

import { shouldShowFeatureFlag } from 'utils/roleAndTenant';
import { getTenantSetting } from 'utils/tenantSettings';

export const PLANNING_WORKFLOW_LIMIT = 500;
export const MIN_MAX_EXPORT_LIMIT = 100;

export function getMinMaxExportRestrictions(activeTenant: TenantDTO, activeUser: ExtendedUser) {
  // for P21 txn-api only tenant, we limit the min/max export to 100 records at a time
  const isTxnApiTenantWithSynchronousExports =
    !getTenantSetting(TenantSettingKey.FeatureAsyncMinMaxExports) &&
    shouldShowFeatureFlag(activeTenant, activeUser, TenantFeatureFlag.ItemLocationMinMaxExportUsingTransactionApi);

  // This setting allows the CS team to manually limit a tenant to exports of MIN_MAX_EXPORT_LIMIT or less during onboarding
  const isRestrictedToSmallExportsOnly = !getTenantSetting(TenantSettingKey.FeatureBulkMinMaxExports);

  return { isTxnApiTenantWithSynchronousExports, isRestrictedToSmallExportsOnly };
}

export const demandPatternOptions: MultiSelectOption[] = [
  {
    label: DemandPattern.SMOOTH,
    value: DemandPattern.SMOOTH,
  },
  {
    label: DemandPattern.SPARSE,
    value: DemandPattern.SPARSE,
  },
  {
    label: DemandPattern.ERRATIC,
    value: DemandPattern.ERRATIC,
  },
  {
    label: DemandPattern.SPORADIC,
    value: DemandPattern.SPORADIC,
  },
  {
    label: DemandPattern.UNSTABLE,
    value: DemandPattern.UNSTABLE,
  },
  {
    label: DemandPattern.NEW_ITEM,
    value: DemandPattern.NEW_ITEM,
  },
  {
    label: DemandPattern.NO_DEMAND,
    value: DemandPattern.NO_DEMAND,
  },
];

export const demandPatternChangeOptions: MultiSelectOption[] = [
  {
    label: DemandPatternChange.NO_CHANGE,
    value: DemandPatternChange.NO_CHANGE,
  },
  {
    label: DemandPatternChange.SPARSE_CHANGE,
    value: DemandPatternChange.SPARSE_CHANGE,
  },
  {
    label: DemandPatternChange.NON_SPARSE_CHANGE,
    value: DemandPatternChange.NON_SPARSE_CHANGE,
  },
];

export const demandPredictabilityOptions: MultiSelectOption[] = [
  {
    label: DemandPredictabilityTag.VeryHigh,
    value: DemandPredictabilityTag.VeryHigh,
  },
  {
    label: DemandPredictabilityTag.High,
    value: DemandPredictabilityTag.High,
  },
  {
    label: DemandPredictabilityTag.Medium,
    value: DemandPredictabilityTag.Medium,
  },
  {
    label: DemandPredictabilityTag.Low,
    value: DemandPredictabilityTag.Low,
  },
];
